import styled from '@emotion/styled';
import {Dropdown} from '@bosch/react-frok';

export const DropdownInput = styled(Dropdown)`
    justify-content: center;
    align-self: center;
    align-items: stretch;
    flex-grow: 2;
    max-width: 45%;
    min-width: 360px;
    margin-right: 0.75rem;
`;
